import {Link, useParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Skeleton} from '@/components/ui/skeleton'
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/components/ui/tabs'
import {NoAccessState} from '@/components/no-access-state'
import {PartnerDetailHeader} from '@/components/partner-detail/header'
import {MiembrosSection} from '@/components/partner-detail/miembros-section'
import {CuposSection} from '@/components/partner-detail/cupos-section'
import {BillingSection} from '@/components/partner-detail/billing-section'
import {useIsSystemUser} from '@/hooks/empresa/organizacion/use-businesses'
import {usePartner} from '@/hooks/inci/aliados/use-partners'

export function PartnerDetailPage() {
  const {t} = useTranslation()
  const {partnerId} = useParams()
  const isSystemUser = useIsSystemUser()
  const {data: partner, isLoading} = usePartner(isSystemUser ? partnerId : undefined)

  if (!isSystemUser) return <NoAccessState />
  if (isLoading) return <Skeleton className="h-64 w-full" />
  if (!partner) return <NoAccessState />

  return (
    <div className="space-y-5" data-testid="partner-detail-page">
      <Link
        to="/admin/partners"
        className="text-[13px] font-medium text-muted-foreground hover:text-foreground"
        data-testid="partner-detail-back">
        {t('partnerDetail.header.backToPartners')}
      </Link>
      <PartnerDetailHeader partner={partner} />

      <Tabs defaultValue="equipo" data-testid="partner-detail-tabs">
        <TabsList>
          <TabsTrigger value="equipo" data-testid="partner-detail-tab-equipo">
            {t('partnerDetail.tabs.equipo')}
          </TabsTrigger>
          <TabsTrigger value="billing" data-testid="partner-detail-tab-billing">
            {t('partnerDetail.tabs.billing')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="equipo" className="space-y-4 pt-4">
          <MiembrosSection partner={partner} />
          <CuposSection partner={partner} />
        </TabsContent>

        <TabsContent value="billing" className="pt-4">
          <BillingSection partner={partner} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
